import BoardPack from '@/components/BoardPack/BoardPack'
import LoadingComponent from '@/components/common/LoadingComponent';
import { usePermissions } from '@/context/PermissionContext';
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getAccessToken } from '@/utils/authSession';

const Mobile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const { triggerPermissionLoad } = usePermissions();

  const user = {
    "user_id": "40",
    "role_id": "25",
    "username": "cb_user",
    "full_name": "CrystalBall",
    "email": "crystalball@codovio.com",
    "phone": "03210021232",
    "owner_company_id": "1",
    "status": "active",
    "last_login": "16-APR-26 10.56.21.178306 AM",
    "role_name": "BP Viewer Mobile",
    "created_by_name": "AbdullahMamji2"
  };
  useEffect(() => {
    const init = async () => {
      setIsLoading(true);
      const localToken = getAccessToken();
      if (localToken) {
        navigate("/board-pack-mobile")
      }

      const token = searchParams.get("access_token");

      if (token) {
        localStorage.setItem("access_token", token);
        localStorage.setItem("user", JSON.stringify(user));

        await triggerPermissionLoad();
      }

      setIsLoading(false);
    };

    init();
  }, []);
  if (isLoading) {
    return <LoadingComponent />
  }

  return (
    <LoadingComponent />
  )
}

export default Mobile;